export const EQUALS = 'equals';
export const CONTAINS = 'contains';
export const IS_NONE = 'isNone';
export const ONE_OF = 'oneOf';
export const IS_TRUTHY = 'isTruthy';
export const IS_FALSY = 'isFalsy';
export const STRICT_EQUAL = 'strictEqual';
export const HAS_KEY = 'hasKey';

export const COMMON_TEXT_OPERATORS = [{ id: EQUALS }, { id: CONTAINS }];
